import axios from 'axios'

// Use production URL for live site, localhost for development
const isProduction = window.location.hostname !== 'localhost';
const baseURL = isProduction ? 'https://api.4pos.online' : 'http://localhost:8000';

const api = axios.create({
    baseURL: `${baseURL}/api`,
    withCredentials: true
})

// Add response interceptor to handle authentication errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle authentication errors (401, 409)
        if (error.response && (error.response.status === 401 || error.response.status === 409)) {
            const errorMessage = error.response.data?.error || 'Authentication failed';
            
            console.log('API authentication error:', {
                status: error.response.status,
                message: errorMessage,
                url: error.config.url
            });
            
            // Check if this is an order status update request - don't auto-redirect for these
            const isOrderStatusUpdate = error.config.url && error.config.url.includes('/order-status/update/');
            
            // Only redirect if the error message indicates authentication failure AND it's not an order status update
            if ((errorMessage.includes('Please login') || errorMessage.includes('Authentication failed')) && !isOrderStatusUpdate) {
                console.log('Redirecting due to authentication error');
                // Clear auth state
                localStorage.removeItem("accessToken");
                
                // Redirect to appropriate login page based on current URL
                const currentPath = window.location.pathname;
                if (currentPath.includes('/admin/')) {
                    window.location.href = '/admin/login';
                } else {
                    window.location.href = '/login';
                }
            } else if (isOrderStatusUpdate) {
                console.log('Authentication error during order status update - not redirecting automatically');
                // For order status updates, let the component handle the error
            }
        }
        return Promise.reject(error);
    }
);

export default api